import { render } from "./KWList.vue?vue&type=template&id=67e00dc4&scoped=true"
import script from "./KWList.vue?vue&type=script&lang=js"
export * from "./KWList.vue?vue&type=script&lang=js"

import "./KWList.vue?vue&type=style&index=0&id=67e00dc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e00dc4"]])

export default __exports__